import { createSlice } from '@reduxjs/toolkit';

export const loaderSlice = createSlice({
    name: 'loader',
    initialState: {
        isShowed: false
    },
    reducers: {
        showLoader: (state) => {
            state.isShowed = true;
        },
        hideLoader: (state) => {
            state.isShowed = false;
        }
    }
});


// Action creators are generated for each case reducer function
export const { showLoader, hideLoader } = loaderSlice.actions;
